// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"ec64f004","327":"ec64f004"}[chunkId] + ".chunk.css";
};